import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const MuiCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .MuiCheckbox-root.Mui-checked.Mui-disabled {
    color: ${COLORS.primary_light_blue5};
  }

  .text {
    line-height: 20px;
    color: ${COLORS.cirrus_black};

    ${responsive.MOBILE`
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `}
  }
`;
